module.exports = __webpack_public_path__ + "static/media/editOne.a1acc734.png";